
import ko from 'rgs-knockout';

import ExtendedAddressEditorModel from './js/model';
import template from './templates/template.html';

ko.components.register('extended-address-editor', {
	viewModel: ExtendedAddressEditorModel,
	template: template(),
});
